import api from "./api";

const CommonAPI = {
    getColumnSetting: (tableKey) => api.get(`/admin/common/column-setting/${tableKey}`),
    insUpdColumnSetting: (params) => api.post(`/admin/common/column-setting`, params),
    getAppRoute: () => api.get(`/admin/common/app-route`),
    getAppRouteById: (id) => api.get(`/admin/common/app-route/${id}`),
    appRouteInsert: (data) => api.post(`/admin/common/app-route/insert`, data),
    appRouteUpdate: (data) => api.post(`/admin/common/app-route/update`, data),
    appRouteDelete: (id) => api.delete(`/admin/common/app-route/delete/${id}`),
    getUploadFile: (fileName) => api.get(`/admin/common/uploads/file/${fileName}`, {
        responseType: "blob"
    }),
    getAssetsFile: (folder, fileName) => api.get(`/admin/common/assets/file/${folder}/${fileName}`, {
        responseType: "blob"
    }),
};

export default CommonAPI;
